<wm-common-overlay-modal
  class="contained-overlay contractor-type-overlay"
  [isOpen]="true"
  [offsetTop]="overlayOffsetTop"
  [height]="overlayAvailableHeight"
  minHeight="0"
  bodyPadding="16px"
  [headerTitle]="vm.isEditMode ? 'Edit Contractor Type' : 'New Contractor Type'"
  maxWidth="100%"
  (closed)="onClose()"
>
  <div class="contractor-form-container">
    <div *ngIf="vm.loadingData" class="loading-wrapper">
      <div
        class="spinner-border text-primary"
        role="status"
        style="width: 3rem; height: 3rem;"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="content-wrapper" *ngIf="!vm.loadingData && !showTestWorkflow">
      <h3 class="main-heading">
        {{ vm.isEditMode ? vm.fullEditingObject.name + ' - ' : '' }}Contractor
        Type Settings
      </h3>

      <div
        *ngIf="vm.isEditMode"
        class="test-workflow-row"
        style="gap: 12px; align-items:center;"
      >
        <div class="test-btn-group" [ngClass]="validationInfo.register.class">
          <wm-common-button
            [data]="{
              text: testRegisterLoading ? 'STARTING...' : 'TEST REGISTER WORKFLOW',
              variant: 'raised',
              className: 'test-workflow-btn',
              disabled: (validity.register.length > 0) || testRegisterLoading,
              onClick: startTestRegistration.bind(this)
            }"
          >
          </wm-common-button>

          <button
            type="button"
            class="test-workflow-icon"
            [ngClass]="validationInfo.register.class"
            [ngbTooltip]="validationInfo.register.text"
            (click)="validateRegisterWorkflow()"
          >
            <i class="material-icons">{{ validationInfo.register.icon }}</i>
          </button>
        </div>

        <div class="test-btn-group" [ngClass]="validationInfo.renewal.class">
          <wm-common-button
            [data]="{
              text: testRenewalLoading ? 'STARTING...' : 'TEST RENEW WORKFLOW',
              variant: 'raised',
              className: 'test-workflow-btn',
              disabled: (validity.renewal.length > 0) || testRenewalLoading,
              onClick: startTestRenewal.bind(this)
            }"
          >
          </wm-common-button>

          <button
            type="button"
            class="test-workflow-icon"
            [ngClass]="validationInfo.renewal.class"
            [ngbTooltip]="validationInfo.renewal.text"
            (click)="validateRenewalWorkflow()"
          >
            <i class="material-icons">{{ validationInfo.renewal.icon }}</i>
          </button>
        </div>
      </div>

      <div [formGroup]="vm.form" class="mt-3">
        <div class="general-settings-section mb-4">
          <span class="sub-heading mb-3 d-block">General Settings</span>

          <div class="form-grid">
            <div class="form-row two-col">
              <div class="col-item">
                <wm-common-textfield
                  formControlName="name"
                  [data]="{
                    label: 'Name',
                    required: true,
                    variant: 'outline',
                    id: 'contractor-name'
                  }"
                >
                </wm-common-textfield>
                <div
                  class="field-error"
                  *ngIf="
                    vm.form.get('name')?.invalid && vm.form.get('name')?.touched
                  "
                >
                  Required
                </div>
              </div>

              <div class="col-item">
                <wm-common-textfield
                  formControlName="description"
                  [data]="{
                    label: 'Description',
                    variant: 'outline',
                    id: 'contractor-desc',
                    type: 'text-area',
                    textAreaRows: 3
                  }"
                >
                </wm-common-textfield>
              </div>
            </div>

            <div class="form-row two-col">
              <div
                class="col-item"
                *ngIf="
                  !vm.isEditMode ||
                  vm.fullEditingObject?.registerWorkflow?.parentWorkflowid
                "
              >
                <label class="bmd-label-floating">
                  Register Workflow Template
                </label>

                <wm-common-dropdown
                  formControlName="registerWorkflowId"
                  [data]="{
                    options: vm.registerWorkflowOptions
                  }"
                >
                </wm-common-dropdown>
              </div>

              <div
                class="col-item"
                *ngIf="
                  !vm.isEditMode ||
                  vm.fullEditingObject?.renewWorkflow?.parentWorkflowid
                "
              >
                <label class="bmd-label-floating">
                  Renew Workflow Template
                </label>

                <wm-common-dropdown
                  formControlName="renewWorkflowId"
                  [data]="{
                    options: vm.renewWorkflowOptions
                  }"
                >
                </wm-common-dropdown>
              </div>
            </div>
            <div class="form-row two-col">
              <div class="col-item">
                <wm-common-dropdown
                  class="exp-dd"
                  formControlName="expirationOption"
                  (change)="onExpirationChange($event)"
                  [data]="{
                    placeholder: 'Expiration Date',
                    options: vm.expirationOptions
                  }"
                >
                </wm-common-dropdown>
              </div>

              <div class="col-item">
                <div *ngIf="vm.selectedExpirationValue === 'custom-months'">
                  <wm-common-textfield
                    formControlName="termLength"
                    [data]="{
                      label: 'Term length (months)',
                      type: 'number',
                      variant: 'outline',
                      required: true
                    }"
                  >
                  </wm-common-textfield>
                </div>
              </div>
            </div>

            <div
              class="form-row"
              *ngIf="vm.selectedExpirationValue === 'custom-formula'"
            >
              <div class="col-item">
                <wm-data-entity-formula
                  [required]="true"
                  [criteria]="vm.customExpirationCriteria"
                  [workflow]="vm.fullEditingObject?.registerWorkflow"
                  [thenLabelGetter]="getThenLabel"
                  (criteriaChanged)="updateExpirationCriteria($event)"
                  formulaTitle="Custom Expiration Date Formula"
                  [onlyGlobalDataEntities]="false"
                >
                </wm-data-entity-formula>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="toggle-container">
                <wm-common-checkbox
                  formControlName="visibleToPublic"
                  [data]="{
                    variant: 'toggle',
                    name: 'visibleToPublic',
                    label: 'Visible to public',
                    checked: vm.form.get('visibleToPublic')?.value
                  }"
                >
                </wm-common-checkbox>
              </div>
            </div>
          </div>

          <div class="form-row mt-3 tags-row" *ngIf="vm.isEditMode">
            <div class="col-item">
              <span class="sub-heading mb-2 d-block">Tags</span>

              <wm-item-tag-list
                [itemTags]="vm.contractorTypeTags"
                (added)="tagAdded($event)"
                (removed)="tagRemoved($event)"
              >
              </wm-item-tag-list>
            </div>
          </div>
        </div>

        <mat-accordion multi *ngIf="vm.isEditMode" displayMode="default">
          <mat-expansion-panel class="flat-panel mb-3" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>SETTINGS</mat-panel-title>
            </mat-expansion-panel-header>

            <div [formGroup]="vm.settingsForm" class="settings-content-wrapper">
              <mat-accordion>
                <mat-expansion-panel class="mb-2">
                  <mat-expansion-panel-header>
                    <mat-panel-title>REGISTRATION</mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-template matExpansionPanelContent>
                    <div class="settings-tab-content pt-2">
                      <div class="mb-4">
                        <h4 class="section-title">
                          Application Description Settings
                        </h4>

                        <div class="form-grid">
                          <div class="form-row">
                            <div class="col-item">
                              <wm-common-textfield
                                formControlName="registerAppDescription"
                                [data]="{
                                  label: 'Application Description Template',
                                  variant: 'outline',
                                  type: 'textarea'
                                }"
                              >
                              </wm-common-textfield>
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="col-item position-relative">
                              <ng-container
                                *ngIf="vm.fullEditingObject?.registerWorkflow"
                              >
                                <wm-data-entity-autocomplete
                                  style="display: block; width: 100%; min-height: 50px;"
                                  [form]="vm.settingsForm"
                                  [id]="'registerAppDescSearchEntities'"
                                  [workflow]="
                                    vm.fullEditingObject.registerWorkflow
                                  "
                                  [workflowId]="
                                    vm.fullEditingObject.registerWorkflowId
                                  "
                                  [types]=""
                                  [showFormulaEditor]="false"
                                  [clearOnSelect]="true"
                                  (valueUpdate)="
                                    onEntitySelected(
                                      $event,
                                      'registerAppDescription'
                                    )
                                  "
                                >
                                </wm-data-entity-autocomplete>
                              </ng-container>

                              <div class="help-text-wrapper">
                                <wm-help-text
                                  [helpText]="'Search variables'"
                                ></wm-help-text>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr class="separator-line my-4" />
                      </div>

                      <div class="card mb-4 border-0">
                        <div class="card-body p-0">
                          <h4 class="section-title">
                            Application Number Settings
                          </h4>

                          <div class="form-grid">
                            <div class="form-row">
                              <div class="col-item">
                                <wm-data-entity-formula
                                  [required]="true"
                                  [workflow]="
                                    vm.fullEditingObject.registerWorkflow
                                  "
                                  [thenLabelGetter]="getThenLabel"
                                  (criteriaChanged)="
                                    updateCriteria(
                                      $event,
                                      vm.fullEditingObject.registerWorkflow,
                                      'registrationNumberPrefix'
                                    )
                                  "
                                  [criteria]="
                                    vm.fullEditingObject.registerWorkflow
                                      .numberPrefixCriteria
                                  "
                                  formulaTitle="Number Prefix"
                                  [onlyGlobalDataEntities]="false"
                                >
                                </wm-data-entity-formula>
                              </div>
                            </div>

                            <div class="form-row two-col">
                              <div class="col-item">
                                <wm-common-textfield
                                  formControlName="registrationStartingNumber"
                                  [data]="{
                                    label: 'Starting Number',
                                    type: 'number',
                                    variant: 'outline'
                                  }"
                                >
                                </wm-common-textfield>
                              </div>

                              <div class="col-item position-relative">
                                <wm-common-textfield
                                  formControlName="registerTotalLength"
                                  [data]="{
                                    label: 'Fixed Number Length',
                                    type: 'number',
                                    variant: 'outline',
                                    helperText:
                                      'Preview: ' +
                                      vm.registerFixedNumberPreview
                                  }"
                                >
                                </wm-common-textfield>

                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Total length'"
                                  ></wm-help-text>
                                </div>
                              </div>
                            </div>

                            <div class="form-row mt-2">
                              <div class="toggle-container">
                                <wm-common-checkbox
                                  formControlName="registerAutoReset"
                                  (change)="toggleAutoReset('register')"
                                  [data]="{
                                    variant: 'toggle',
                                    label: 'Auto Reset?',
                                    checked: vm.settingsForm.get(
                                      'registerAutoReset'
                                    )?.value
                                  }"
                                >
                                </wm-common-checkbox>
                                <wm-help-text
                                  [helpText]="'Reset counter annually?'"
                                ></wm-help-text>
                              </div>
                            </div>

                            <div
                              class="form-row two-col mt-3"
                              *ngIf="
                                vm.settingsForm.get('registerAutoReset')?.value
                              "
                            >
                              <div class="col-item position-relative">
                                <wm-common-dropdown
                                  formControlName="registerResetMonth"
                                  [data]="{
                                    placeholder: 'Month of Year',
                                    options: vm.monthOptions
                                  }"
                                >
                                </wm-common-dropdown>
                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Month to reset'"
                                  ></wm-help-text>
                                </div>
                              </div>

                              <div class="col-item position-relative">
                                <wm-common-dropdown
                                  formControlName="registerResetDay"
                                  [data]="{
                                    placeholder: 'Day of Month',
                                    options: vm.dayOptions
                                  }"
                                >
                                </wm-common-dropdown>
                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Day to reset'"
                                  ></wm-help-text>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0">
                        <div class="card-body p-0 pt-3 border-top">
                          <div class="toggle-container">
                            <wm-common-checkbox
                              formControlName="registrationEnableAutoVoid"
                              [data]="{
                                variant: 'toggle',
                                label: 'Auto Void Application Settings',
                                checked: vm.settingsForm.get(
                                  'registrationEnableAutoVoid'
                                )?.value
                              }"
                            >
                            </wm-common-checkbox>
                          </div>

                          <div
                            class="mt-3"
                            *ngIf="
                              vm.fullEditingObject?.registerWorkflow
                                ?.autoVoidSettings
                            "
                            formGroupName="registrationAutoVoid"
                          >
                            <div class="form-grid">
                              <div class="form-row two-col">
                                <div class="col-item">
                                  <label class="bmd-label-floating"
                                    >Activity to go beyond</label
                                  >
                                  <select
                                    class="form-control"
                                    formControlName="goBeyondActivity"
                                  >
                                    <option
                                      *ngFor="
                                        let activity of vm.registrationAutoVoidActivities
                                      "
                                      [value]="activity.id"
                                    >
                                      {{ activity.model.screenName }}
                                    </option>
                                  </select>
                                </div>

                                <div class="col-item">
                                  <wm-common-textfield
                                    formControlName="daysUntilVoid"
                                    [data]="{
                                      label: 'Days until void',
                                      type: 'number',
                                      variant: 'outline',
                                      required: true
                                    }"
                                  >
                                  </wm-common-textfield>
                                </div>
                              </div>

                              <div
                                class="form-row"
                                *ngIf="vm.registrationAutoVoidExample"
                              >
                                <div class="col-item">
                                  <p class="text-muted small">
                                    <i
                                      >Example:
                                      {{ vm.registrationAutoVoidExample }}</i
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="card border-0 mt-4"
                        *ngIf="vm.fullEditingObject?.registerWorkflow"
                      >
                        <div class="card-body p-0 pt-3 border-top">
                          <wm-workflow-category-list
                            [workflowCategories]="registerWorkflowCategories"
                            [workflowId]="
                              vm.fullEditingObject.registerWorkflow.id ||
                              vm.fullEditingObject.registerWorkflowId
                            "
                            [categoriesEnabled]="registerCategoriesEnabled"
                            (categoriesChanged)="
                              onRegisterCategoriesChanged($event)
                            "
                            (categoriesEnabledChanged)="
                              onRegisterCategoriesEnabledChanged($event)
                            "
                          >
                          </wm-workflow-category-list>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel class="mb-2">
                  <mat-expansion-panel-header>
                    <mat-panel-title>RENEWAL</mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-template matExpansionPanelContent>
                    <div class="settings-tab-content pt-2">
                      <div class="mb-4">
                        <h4 class="section-title">
                          Application Description Settings
                        </h4>

                        <div class="form-grid">
                          <div class="form-row">
                            <div class="col-item">
                              <wm-common-textfield
                                formControlName="renewalAppDescription"
                                [data]="{
                                  label: 'Application Description Template',
                                  variant: 'outline',
                                  type: 'textarea'
                                }"
                              >
                              </wm-common-textfield>
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="col-item position-relative">
                              <ng-container
                                *ngIf="vm.fullEditingObject?.renewWorkflow"
                              >
                                <wm-data-entity-autocomplete
                                  style="display: block; width: 100%; min-height: 50px;"
                                  [form]="vm.settingsForm"
                                  [id]="'renewalAppDescSearchEntities'"
                                  [workflow]="
                                    vm.fullEditingObject.renewWorkflow
                                  "
                                  [workflowId]="
                                    vm.fullEditingObject.renewWorkflowId
                                  "
                                  [types]=""
                                  [showFormulaEditor]="false"
                                  [clearOnSelect]="true"
                                  (valueUpdate)="
                                    onEntitySelected(
                                      $event,
                                      'renewalAppDescription'
                                    )
                                  "
                                >
                                </wm-data-entity-autocomplete>
                              </ng-container>

                              <div class="help-text-wrapper">
                                <wm-help-text
                                  [helpText]="'Search variables'"
                                ></wm-help-text>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr class="separator-line my-4" />
                      </div>

                      <div class="card mb-4 border-0">
                        <div class="card-body p-0">
                          <h4 class="section-title">
                            Application Number Settings
                          </h4>

                          <div class="form-grid">
                            <div class="form-row">
                              <div class="col-item">
                                <wm-data-entity-formula
                                  [required]="true"
                                  [workflow]="
                                    vm.fullEditingObject.renewWorkflow
                                  "
                                  [thenLabelGetter]="getThenLabel"
                                  (criteriaChanged)="
                                    updateCriteria(
                                      $event,
                                      vm.fullEditingObject.renewWorkflow,
                                      'renewalNumberPrefix'
                                    )
                                  "
                                  [criteria]="
                                    vm.fullEditingObject.renewWorkflow
                                      .numberPrefixCriteria
                                  "
                                  formulaTitle="Number Prefix"
                                  [onlyGlobalDataEntities]="false"
                                >
                                </wm-data-entity-formula>
                              </div>
                            </div>

                            <div class="form-row two-col">
                              <div class="col-item">
                                <wm-common-textfield
                                  formControlName="renewalStartingNumber"
                                  [data]="{
                                    label: 'Starting Number',
                                    type: 'number',
                                    variant: 'outline'
                                  }"
                                >
                                </wm-common-textfield>
                              </div>

                              <div class="col-item position-relative">
                                <wm-common-textfield
                                  formControlName="renewalTotalLength"
                                  [data]="{
                                    label: 'Fixed Number Length',
                                    type: 'number',
                                    variant: 'outline',
                                    helperText:
                                      'Preview: ' + vm.renewalFixedNumberPreview
                                  }"
                                >
                                </wm-common-textfield>

                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Total length'"
                                  ></wm-help-text>
                                </div>
                              </div>
                            </div>

                            <div class="form-row mt-2">
                              <div class="toggle-container">
                                <wm-common-checkbox
                                  formControlName="renewalAutoReset"
                                  (change)="toggleAutoReset('renewal')"
                                  [data]="{
                                    variant: 'toggle',
                                    label: 'Auto Reset?',
                                    checked: vm.settingsForm.get(
                                      'renewalAutoReset'
                                    )?.value
                                  }"
                                >
                                </wm-common-checkbox>
                                <wm-help-text
                                  [helpText]="'Reset counter annually?'"
                                ></wm-help-text>
                              </div>
                            </div>

                            <div
                              class="form-row two-col mt-3"
                              *ngIf="
                                vm.settingsForm.get('renewalAutoReset')?.value
                              "
                            >
                              <div class="col-item position-relative">
                                <wm-common-dropdown
                                  formControlName="renewalResetMonth"
                                  [data]="{
                                    placeholder: 'Month of Year',
                                    options: vm.monthOptions
                                  }"
                                >
                                </wm-common-dropdown>
                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Month to reset'"
                                  ></wm-help-text>
                                </div>
                              </div>

                              <div class="col-item position-relative">
                                <wm-common-dropdown
                                  formControlName="renewalResetDay"
                                  [data]="{
                                    placeholder: 'Day of Month',
                                    options: vm.dayOptions
                                  }"
                                >
                                </wm-common-dropdown>
                                <div class="help-text-wrapper input-aligned">
                                  <wm-help-text
                                    [helpText]="'Day to reset'"
                                  ></wm-help-text>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0">
                        <div class="card-body p-0 pt-3 border-top">
                          <div class="toggle-container">
                            <wm-common-checkbox
                              formControlName="renewalEnableAutoVoid"
                              [data]="{
                                variant: 'toggle',
                                label: 'Auto Void Application Settings',
                                checked: vm.settingsForm.get(
                                  'renewalEnableAutoVoid'
                                )?.value
                              }"
                            >
                            </wm-common-checkbox>
                          </div>

                          <div
                            class="mt-3"
                            *ngIf="
                              vm.fullEditingObject?.renewWorkflow
                                ?.autoVoidSettings
                            "
                            formGroupName="renewalAutoVoid"
                          >
                            <div class="form-grid">
                              <div class="form-row two-col">
                                <div class="col-item">
                                  <label class="bmd-label-floating"
                                    >Activity to go beyond</label
                                  >
                                  <select
                                    class="form-control"
                                    formControlName="goBeyondActivity"
                                  >
                                    <option
                                      *ngFor="
                                        let activity of vm.renewalAutoVoidActivities
                                      "
                                      [value]="activity.id"
                                    >
                                      {{ activity.model.screenName }}
                                    </option>
                                  </select>
                                </div>

                                <div class="col-item">
                                  <wm-common-textfield
                                    formControlName="daysUntilVoid"
                                    [data]="{
                                      label: 'Days until void',
                                      type: 'number',
                                      variant: 'outline',
                                      required: true
                                    }"
                                  >
                                  </wm-common-textfield>
                                </div>
                              </div>

                              <div
                                class="form-row"
                                *ngIf="vm.renewalAutoVoidExample"
                              >
                                <div class="col-item">
                                  <p class="text-muted small">
                                    <i
                                      >Example:
                                      {{ vm.renewalAutoVoidExample }}</i
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="card border-0 mt-4"
                        *ngIf="vm.fullEditingObject?.renewWorkflow"
                      >
                        <div class="card-body p-0 pt-3 border-top">
                          <wm-workflow-category-list
                            [workflowCategories]="renewalWorkflowCategories"
                            [workflowId]="
                              vm.fullEditingObject.renewWorkflow.id ||
                              vm.fullEditingObject.renewWorkflowId
                            "
                            [categoriesEnabled]="renewalCategoriesEnabled"
                            (categoriesChanged)="
                              onRenewalCategoriesChanged($event)
                            "
                            (categoriesEnabledChanged)="
                              onRenewalCategoriesEnabledChanged($event)
                            "
                          >
                          </wm-workflow-category-list>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel class="flat-panel mb-3">
            <mat-expansion-panel-header>
              <mat-panel-title>REQUIREMENTS</mat-panel-title>
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <div class="p-3">
                <div class="card mb-4 border-0">
                  <div class="card-body p-0">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <h5 class="mb-0">Contractor Requirements</h5>
                      <wm-common-button
                        [data]="{ text: 'Add Requirement', variant: 'raised', onClick: addNewContractorRequirement.bind(this) }"
                      >
                      </wm-common-button>
                    </div>

                    <p class="text-muted small mb-3">
                      A Contractor Requirement may be applied to a Data Entity
                      on any Contractor Info Form Activity in the Register
                      Workflow.
                    </p>

                    <ul class="list-group">
                      <li
                        class="list-group-item mb-3 border rounded"
                        *ngIf="vm.newContractorRequirement"
                      >
                        <wm-contractor-requirement-editor
                          [requirement]="vm.newContractorRequirement"
                          [parentForm]="vm.form"
                          [entities]="vm.availableContractorEntities"
                          (cancelled)="newContractorRequirementCancelled()"
                          (applied)="newRequirementApplied($event)"
                          [isOpen]="true"
                        >
                        </wm-contractor-requirement-editor>
                      </li>

                      <li
                        class="list-group-item border-0 p-0 mb-2"
                        *ngIf="
                          !vm.contractorRequirements ||
                          vm.contractorRequirements.length === 0
                        "
                      >
                        <i
                          >There are not any Contractor Requirements for this
                          Contractor Type</i
                        >
                      </li>

                      <li
                        class="list-group-item mb-3 border rounded"
                        *ngFor="let requirement of vm.contractorRequirements"
                      >
                        <wm-contractor-requirement-editor
                          [requirement]="requirement"
                          [parentForm]="vm.form"
                          [entities]="vm.contractorEntities"
                          (removed)="removeRequirement($event)"
                          (applied)="onSave()"
                        >
                        </wm-contractor-requirement-editor>
                      </li>
                    </ul>
                  </div>
                </div>

                <hr class="separator-line my-4" />

                <div class="card border-0">
                  <div class="card-body p-0">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <h5 class="mb-0">Registration Requirements</h5>
                      <wm-common-button
                        [data]="{ text: 'Add Requirement', variant: 'raised', onClick: addNewRegistrationRequirement.bind(this) }"
                      >
                      </wm-common-button>
                    </div>

                    <p class="text-muted small mb-3">
                      A Registration Requirement may be applied to a Data Entity
                      on any Contractor Registration Info Form Activity in the
                      Register Workflow.
                    </p>

                    <ul class="list-group">
                      <li
                        class="list-group-item mb-3 border rounded"
                        *ngIf="vm.newRegistrationRequirement"
                      >
                        <wm-contractor-requirement-editor
                          [requirement]="vm.newRegistrationRequirement"
                          [parentForm]="vm.form"
                          [entities]="vm.availableRegistrationEntities"
                          (cancelled)="newRegistrationRequirementCancelled()"
                          (applied)="newRequirementApplied($event)"
                          [isOpen]="true"
                        >
                        </wm-contractor-requirement-editor>
                      </li>

                      <li
                        class="list-group-item border-0 p-0 mb-2"
                        *ngIf="
                          !vm.registrationRequirements ||
                          vm.registrationRequirements.length === 0
                        "
                      >
                        <i
                          >There are not any Registration Requirements for this
                          Contractor Type</i
                        >
                      </li>

                      <li
                        class="list-group-item mb-3 border rounded"
                        *ngFor="let requirement of vm.registrationRequirements"
                      >
                        <wm-contractor-requirement-editor
                          [requirement]="requirement"
                          [parentForm]="vm.form"
                          [entities]="vm.registrationEntities"
                          (removed)="removeRequirement($event)"
                          (applied)="onSave()"
                        >
                        </wm-contractor-requirement-editor>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel
            class="flat-panel mb-3"
            [disabled]="!vm.isEditMode"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                ADVANCED PERMISSIONS
                <span
                  *ngIf="!vm.isEditMode"
                  class="text-muted ml-2"
                  style="font-size: 12px; line-height: 24px;"
                >
                  (Save first to configure)
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <div class="p-3">
                <ng-container *ngIf="vm.isEditMode && vm.fullEditingObject">
                  <wm-advanced-permissions-editor
                    [securable]="vm.fullEditingObject"
                    [showExpandCollapse]="false"
                    permissionTitle="Permissions for this contractor type"
                  >
                  </wm-advanced-permissions-editor>
                </ng-container>

                <p *ngIf="!vm.isEditMode" class="text-muted">
                  You must save this Contractor Type before configuring advanced
                  permissions.
                </p>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <div class="workflow-child-container" *ngIf="showTestWorkflow">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div modal-footer *ngIf="!vm.loadingData && !showTestWorkflow">
    <wm-common-button
      class="cancel-btn"
      [data]="{ text: 'CANCEL', variant: 'flat', onClick: onClose.bind(this) }"
    >
    </wm-common-button>

    <wm-common-button
      class="save-btn"
      [data]="{ text: vm.saving ? 'SAVING...' : 'SAVE', variant: 'raised', disabled: vm.saving, onClick: onSave.bind(this) }"
    >
    </wm-common-button>
  </div>
</wm-common-overlay-modal>
